import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useTable } from "react-table";
import styled from "styled-components";
import { Table, TableHead, TableRow, TableHeadCell, TableBody, TableDataCell } from "react95";
import useSelectedScraper from "../../hooks/useSelectedScraper";
import scraperConfig from "../../scraperConfig";

const Container = styled.div`
    margin-top: 10px;
    max-height: 350px;
    overflow-y: scroll;

    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 25px;
        height: 25px;
        position: absolute;
    }

    ::-webkit-scrollbar-track {
        background: #ddd;
        border-left: 2px solid #888c8f;
        border-style: solid;
        border-width: 2px;
        border-top-color: #888c8f;
        border-right-color: #ffffff;
        border-bottom-color: #ffffff;
    }

    ::-webkit-scrollbar-thumb {
        background: #ced0cf;
        border-style: solid;
        border-width: 2px;
        border-left-color: #ffffff;
        border-top-color: #ffffff;
        border-right-color: #050608;
        border-bottom-color: #050608;
        box-shadow: inset 1px 1px 0px 1px #dfe0e3, inset -1px -1px 0 1px #888c8f;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #ced0cf;
    }

    @media (max-width: 768px) {
        max-width: calc(100vw - 42px);
        overflow-x: scroll;
    }
`;

const TrackTable = ({ data }) => {
    const selectedScraper = useSelectedScraper();
    const columns = useMemo(() => scraperConfig[selectedScraper].tableConfig, [selectedScraper]);

    const { getTableProps, getTableBodyProps, prepareRow, rows, headerGroups } = useTable({
        columns,
        data
    });

    return (
        <Container>
            <Table style={{ minWidth: "600px" }} {...getTableProps()}>
                <TableHead>
                    {headerGroups.map((headerGroup) => (
                        <TableRow head {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <TableHeadCell {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </TableHeadCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>

                <TableBody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <TableRow {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    return (
                                        <TableDataCell
                                            {...cell.getCellProps()}
                                            style={{ textAlign: "Left" }}
                                        >
                                            {cell.render("Cell")}
                                        </TableDataCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </Container>
    );
};

TrackTable.propTypes = {
    data: PropTypes.instanceOf(Array).isRequired
};

export default TrackTable;
